import { render, staticRenderFns } from "./help.vue?vue&type=template&id=1dd8a50f"
import script from "./help.js?vue&type=script&lang=js&external"
export * from "./help.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports